// import logo from './logo.svg';
import React from 'react';
import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import './css/bootstrap.css'
import './css/style.css'
import './css/responsive.css'
import './css/general.css'
import './css/tiles.css'
import { BrowserRouter, MemoryRouter, Routes, Route } from "react-router";
import Main from "./pages/Main"
import Layout from './templates/Layout';
import NoPage from "./pages/NoPage";
import Lesson from './pages/Lesson';
import Lessons from './pages/Lessons';
import Lessenrooster from './pages/Lessenrooster';
import AboutUs from './pages/AboutUs';
import Workshops from './pages/Workshops';
import ScrollToTop from './components/ScrollToTop';
import Events from "./pages/Events"
import Event from "./pages/Event"
import ProtectedRoute from './components/ProtectedRoute';
import Admin from './pages/Admin';
import ImageManagement from './pages/ImageManagement';
// Configure Amplify  
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_AUTH_DOMAIN,
          scope: ['email', 'profile', 'openid'],
          redirectSignIn: [process.env.REACT_APP_REDIRECT_SIGN_IN],
          redirectSignOut: [process.env.REACT_APP_REDIRECT_SIGN_OUT],
          responseType: 'code',
        },
        username: 'true'
      }
    }
  },
  API: {
    endpoints: [
      {
        name: 'calendar-api',
        endpoint: process.env.REACT_APP_API_ENDPOINT,
        region: 'eu-west-1'
      },
    ]
  }
});

function App({test}) {
  const Router = test ? React.Fragment : (process.env.NODE_ENV === 'test' ? MemoryRouter : BrowserRouter);
  return (
    <Router>
      <ScrollToTop test={test} />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="evenementen" element={<Events />} />
          <Route path="evenementen/:eventId" element={<Event />} />
          <Route path="lessen" element={<Lessons />} />
          <Route path="lessen/:lessonId" element={<Lesson />} />
          <Route path="lessenrooster" element={<Lessenrooster />} />
          <Route path="over-ons" element={<AboutUs />} />
          <Route path="workshops" element={<Workshops />} />
          <Route path="admin" element={<ProtectedRoute Component={Admin} />} />
          <Route path="admin/images" element={<ProtectedRoute Component={ImageManagement} />} />
          {/* <Route path="auditie" element={<Audition />} /> */}
          <Route index element={<Main />} />
          <Route path="*" element={<NoPage />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;
